import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { ColumnMapping } from './MappingTable';

interface EditModeActionsProps {
  editingMappings: ColumnMapping[];
  saving?: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const EditModeActions: React.FC<EditModeActionsProps> = ({
  editingMappings,
  saving = false,
  onCancel,
  onSave
}) => {
  const hasMappings = editingMappings.some((m) => m.crmField !== null);

  return (
    <Box
      sx={{
        mt: 3,
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        flexShrink: 0
      }}
    >
      <Box display="flex" gap={1}>
        <Button
          variant="outlined"
          fullWidth
          onClick={onCancel}
          disabled={saving}
          sx={(theme) => ({
            border: `1px solid ${theme.customColors?.themePrimary || 'primary.main'}`,
            backgroundColor: theme.customColors?.themeSecondary,
            color: theme.customColors?.themePrimary || 'primary.main',
            borderRadius: '50px',
            textTransform: 'capitalize'
          })}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          fullWidth
          onClick={onSave}
          disabled={!hasMappings || saving}
          sx={(theme) => ({
            border: `1px solid ${theme.customColors?.themePrimary || 'primary.main'}`,
            backgroundColor: theme.customColors?.themePrimary || 'primary.main',
            color: theme.customColors?.themeSecondary || 'white',
            borderRadius: '50px',
            textTransform: 'capitalize',
            '&:disabled': {
              borderColor: 'inherit',
              opacity: 0.6
            }
          })}
        >
          {saving ? <CircularProgress size={20} color="inherit" /> : 'Save'}
        </Button>
      </Box>
    </Box>
  );
};

export default EditModeActions;
